<template>
  <div
    v-if="loading"
    v-loading="loading"
    style="width:100%;height:100%;" 
    element-loading-background="transparent"
  />
  <div
    v-else
    :class="{ shadow: true, 'shadow_mid': !shadowClass, 'shadow_normal': shadowClass, 'shadow_average': showAverage}"
  >
    <div
      v-for="item in showData"
      :key="item.name"
      class="shadow_item"
    >
      <div class="shadow_sub_item flex_row">
        <img :src="require('@/assets/images/'+item.icon+'.png')"><label>{{ item.name }}</label>    
      </div> 
      <span>{{ item.value }}件</span>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    showData:{
      type:Array,
      default:()=>[]
    },
    shadowClass:{
      type:Boolean,
      default:true
    },
    showAverage:{
      type:Boolean,
      default:false,
    }
  },
  data(){
    return {
      loading:true
    }
  },
  watch:{
    showData:{
      handler(val){
        if(val.length > 0){
          this.loading = false
        }
      },
      deep:true
    }
  }
}
</script>
<style lang="scss">
  .shadow{
    width:100%;
    height:100%;
    display:flex;
    flex-direction:column;
    justify-content: space-between;
    .shadow_item{
      color:#fff;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      align-items: center;     
      .shadow_sub_item{
        align-items: center;
        justify-content: center;
      }
      img{
        display:inline-block;
        width:25px;
        height:25px;
        border:none;
      }
      label{
        font-weight: 700;
        font-style: normal;
        font-size: 14px;
        color: #ABBEF1;
        padding-left:10px;
      }
      span{
        font-size: 14px;
        color: #FFFFFF;
      }
    }
    .shadow_child{
      color:#fff;
      font-size:13px;
      justify-content: space-evenly; 
      >p{
        justify-content: space-between;
      }      
    }
    &.shadow_normal{
      align-items:center;
      justify-content: space-evenly;
      padding: 0 20px;
      box-sizing: border-box;
    }
    &.shadow_mid{

      >div{
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 20px 0 30px;
        box-sizing: border-box;
      }
      >div:not(:last-child){
        border-bottom:1px solid #1f2354;
        // border-bottom:1px solid #fff;
      }
      >div:not(:first-child){
        height:95px;
      }
      .shadow_item:not(:first-child){
        height:95px;
      }
      .shadow_item:first-child{
        height:60px;
      }
      .shadow_child{
        height:132px;        
      }
    }
    &.shadow_average{
      display:flex;
      flex-direction: row;
      justify-content: space-evenly;
      >div{
        width:25%;
        display: flex;
        flex-direction: row;
        // padding:0 20px;
      }

    }
  }
  
</style>